import React from "react";
import Categories from "./Categories";
import { useTranslation } from "../hooks/hooks";
import { Category } from "../interfaces/intefaces";
import { ArrowRightIcon, ProvidersIcon } from "./Icons";
import Icon from "./Icon";
import { useAtom } from "jotai";
import { categoryTypeAtom, showProvidersAtom } from "../state/games";
interface IProps {
    categories: Category[] | null;
    activeCategory: number;
    updateCategory: (category_id: number) => void;
    setCategoryType: (categoryType: number) => void;
}

const Sidebar = ({ categories, activeCategory, updateCategory, setCategoryType }: IProps) => {
    const { _e } = useTranslation();
    const [showProviders, setShowProviders] = useAtom(showProvidersAtom);
    const [categoryType] = useAtom(categoryTypeAtom);

    return (
        <>
            {categories && (
                <div className="col-left">
                    <Categories
                        categories={categories}
                        activeCategory={activeCategory}
                        updateCategory={updateCategory}
                        setCategoryType={setCategoryType}
                    />
                    <div className="all-providers">
                        <div
                            onClick={() => {
                                setShowProviders(!showProviders);
                            }}
                            title={_e("ALL PROVIDERS")}
                        >
                            <Icon icon={ProvidersIcon} />
                            <span className="title">{_e("ALL PROVIDERS")}</span>
                        </div>
                    </div>
                    <div className={categoryType === 1 ? "live-casino-link" : "casino-link"}>
                        {categoryType === 1 ? (
                            <a title={_e("LIVE CASINO")} href="/live-casino">
                                <span>{_e("LIVE CASINO")}</span>
                                <Icon icon={ArrowRightIcon} />
                            </a>
                        ) : (
                            <a title={_e("CASINO")} href="/casino">
                                <span>{_e("CASINO")}</span>
                                <Icon icon={ArrowRightIcon} />
                            </a>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Sidebar;
